import api from "./api";

export function createChannel(data) {
  return api.post("/channels", data);
}

export function getAllChannels() {
  return api.get("/channels");
}

export function getAllChannelsOfUser(id) {
  return api.get(`/channels-by-memberId/${id}`);
}

export function updateChannel(id, data) {
  return api.put(`/channels/${id}`, data);
}

export function removeChannel(id) {
  return api.delete(`/delete-channels/${id}`);
}

// ******message***********

export function getMessageByChannelId(id) {
  return api.get(`/channels/${id}/messages`);
}

export function sendChannelMessage(id, data) {
  return api.post(`/channels/${id}/messages`, data);
}

export function viewAllMessages(data) {
  return api.post(`/view-Messgaes`, data);
}

export function deleteChannelMessage(messageId) {
  return api.delete(`/channels/messages/${messageId}`);
}

export function markChannelAsRead(channelId, userId, lastReadAt) {
  return api.post(`/channels/${channelId}/mark-as-read`, { userId, lastReadAt });
}
